import { styled } from 'styled-components';

import { BodySmall } from '#/components/Text/BodySmall';
import { colors, transition } from '#/theme/theme';

export const Description = styled(BodySmall)`
  *:last-child {
    margin-bottom: 0;
  }

  ul {
    padding-left: 24px;
    list-style-type: none;

    li {
      position: relative;

      &::before {
        content: '•';
        position: absolute;
        right: 100%;
        width: 24px;
        text-align: left;
      }
    }
  }
`;

export const BigButton = styled.button`
  cursor: pointer;
  display: block;
  width: 100%;
  box-shadow:
    0 -4px white inset,
    0 4px white inset;
  text-align: left;
  transition: all ${transition};
  font-size: 20px;

  &:hover,
  &:focus {
    background: ${colors.backgroundGrey};

    span {
      text-decoration: underline;
    }
  }
`;
